<div
    class="bg-white p-medpace"
    [style.max-width]="modalConfig.maxWidth"
    [style.min-width]="modalConfig.minWidth"
    [style.width]="modalConfig.width"
>
    <medpace-payment-request-status-change-modal-content
        [formGroup]="formGroup"
        [requestType]="requestType()"
        [requestId]="customParams().requestData.requestId"
        (cancel)="cancel()"
        (confirm)="confirm($event)"
    />
</div>
